import React, { useContext } from 'react';
export var Context = /*#__PURE__*/React.createContext(undefined);
export function useCommentsContext() {
  var context = useContext(Context);
  if (context === undefined) {
    throw Error('useCommentsContext must be used inside of a CommentProvider');
  }
  return context;
}